import { render, staticRenderFns } from "./sba-alert.vue?vue&type=template&id=0cd5552c&"
import script from "./sba-alert.vue?vue&type=script&lang=js&"
export * from "./sba-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports